import React from "react"
import Link from "next/link"

export default function ArticleListItem({ article }) {
  return (
    <Link as={`/blog/${article?.attributes?.slug}?id=${article?.id}`} href="/blog/[slug]" className="article-list-item " key={article?.attributes?.slug} passHref>
      <div className="article-list-item">
        <div className="">
          <p id="category" className=""></p>
          <i className="icon icon-2 far fa-long-arrow-right"></i>
          <p id="title" className="article-list-item__title link">
            {article?.attributes?.title}
          </p>
        </div>
      </div>
    </Link>
  )
}
